var $c5ac7ec630c67dba$exports = {};
$c5ac7ec630c67dba$exports = {
  "pending": `\u{432} \u{43E}\u{436}\u{438}\u{434}\u{430}\u{43D}\u{438}\u{438}`
};
export { $c5ac7ec630c67dba$exports as default };